/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notifications-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-end;position:fixed;right:1vw;bottom:1vw;z-index:9999}.notifications-wrapper[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:not(:last-of-type){margin-bottom:1vw}.notifications-wrapper.position-lb[_ngcontent-%COMP%]{right:auto;left:1vw}.notifications-wrapper.position-tr[_ngcontent-%COMP%]{bottom:auto;top:1vw}.notifications-wrapper.position-tl[_ngcontent-%COMP%]{bottom:auto;right:auto;top:1vw;left:1vw}"];
export { styles as styles };
